import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore, DocumentReference, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {

  constructor(private afFirestore: AngularFirestore) {}

  transform(values: DocumentData[], ...args: any[]): /*Observable<any>*/ number {      
    let retValue = 0;
    if( values != null && values != undefined ){
      values.forEach(
        value => {
          retValue += value.count;
        }
      );
    }    
    return retValue;
  }

}
